<script>
import pagination from "@/mixins/pagination";
import tableSearch from "@/mixins/tableSearch";
import RefreshSearchBtn from "@/views/pages/project/sale/RefreshSearchBtn.vue";
import CommonTableComponent from "@/components/table.vue";
import router from "@/mixins/router";
import ChooseWorkOrderTypeModal from "@/views/pages/project/sale/instruction/modals/ChooseWorkOrderTypeModal.vue";
import apiEndpoints from "@/services/apiEndpoints";

export default {
  name: "WorkOrderTab",
  mixins: [pagination, tableSearch, router],
  components: {
    RefreshSearchBtn,
    CommonTableComponent,
    ChooseWorkOrderTypeModal
  },
  props: {
    activeTabIndex: {
      type: Number,
      default: 0
    },
    disableEntry: {
      type: Boolean,
      default: true
    }

  },
  data() {
    return {
      workOrders: [],
      filters: {
        keyword: this.$route.query.keyword ? this.$route.query.keyword : "",
        column: this.$route.query.column || "",
        dir: this.$route.query.dir || "DESC"
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.$emit("get-data", true);
      const url = apiEndpoints.projects_sales_work_orders(this.projectId); // WorkOrderController->indexByProject
      const sendApiProject = await this.$http.get(url, this.filters);
      const { status, data } = sendApiProject;

      if (status) {
        this.workOrders = data.result;
      }
      this.$emit("get-data", false);
    },
    handlerSearchValue() {
      this.updateUrlFilters();
    },
    showCopyButton(item){
      return item.zz_work_flow_output_statuses_work_flow_output_status == "承認済";
    }

  },
  watch: {
    "filters.page": {
      immediate: false,
      handler() {
        this.updateUrlFilters();
      }
    }
  },
  computed: {
    customQuery() {
      return {
        activeTabIndex: this.activeTabIndex
      };
    },
    headers() {
      return [
        {
          text: "作業指示番号",
          value: "work_order_id",
          sortable: true,
        },
        {
          text: "作業指示名称",
          value: "work_order_name",
          sortable: true
        },
        {
          text: "作業分類",
          value: "zz_work_order_types_sort_order",
          sortable: true
        },
        {
          text: "承認状況",
          value: "zz_work_flow_output_statuses_sort_order",
          sortable: true,
        },
        {
          text: "承認者",
          value: "user_name",
          sortable: true
        },
        {
          text: "",
          value: "open_copy",
          sortable: false
        },
      ];
    },
    projectId() {
      return this.$route.params.id;
    },
    queryPage() {
      return this.$route.query;
    },
  }
};
</script>
<template>
  <b-container>
    <b-row align-h="center">
      <!-- <div class="mb-2">
        <ChooseWorkOrderTypeModal />
      </div> -->
      <b-row>
        <b-col style="padding: 0;">
          <h5 style="margin-top: 11px;">作業指示一覧</h5>
        </b-col>
        <b-col class="d-flex justify-content-end" style="padding: 0;">
          <ChooseWorkOrderTypeModal :disableEntry="this.disableEntry"/>
        </b-col>
      </b-row>
      <div class="mt-1">
        <input
          placeholder="フィルター..."
          v-model="filters.keyword"
          v-on:keyup.enter="handlerSearchValue()"
          type="text"
          class="form-control me-2"
        />
      </div>
      <b-col class="mt-1">
        <CommonTableComponent
          :height-class="`table-wrapper-500`"
          :scrollAble="workOrders.length >= this.$constant.scroll_able_records"
        >
          <thead class="table-light">
            <tr>
              <th
                v-for="(item, index) in headers"
                :key="index"
                :class="getHeaderClass(item)"
              >
                <span v-if="item.sortable" @click="clickSort(item.value)">
                  {{ item.text }}
                  <i :class="getSortClass(item.value)"></i>
                </span>
                <span v-else>
                  {{ item.text }}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in workOrders"
              :key="index"
              @click.exact="
                redirectRoute(
                  'projects.sales.instructions.detail',
                  {
                    id: projectId,
                    work_order_id: item.work_order_id_hidden
                  },
                  {tmp: item.tmp, work_order_id: item.work_order_id, draft:item.draft},
                  queryPage,
                  'projects/sales/instruction'
                )
              "
              @click.ctrl="
                redirectRouteTargetBlank(
                  'projects.sales.instructions.detail',
                  {
                    id: projectId,
                    work_order_id: item.work_order_id_hidden
                  },
                  {tmp: item.tmp, work_order_id: item.work_order_id},
                  queryPage,
                  'projects/sales/instruction'
                )
              "
              class="cursor-pointer"
            >
              <td>
                {{ item.work_order_id }}
              </td>
              <td>
                {{ item.work_order_name  }}
              </td>
              <td>
                {{ item.zz_work_order_types_work_order_type }}
              </td>
              <td>
                {{ item.zz_work_flow_output_statuses_work_flow_output_status }}
              </td>
              <td>
                {{ item.user_name }}
              </td>
              <td @click.stop>

                  <button
                    class="btn btn-primary w-md waves-effect waves-light"
                    v-if="showCopyButton(item)"
                    @click.exact="
                      redirectRoute(
                        'projects.sales.instructions.detail',
                        {
                          id: projectId,
                          work_order_id: item.work_order_id_hidden
                        },
                        {tmp: false, copy: true},
                        queryPage,
                        'projects/sales/instruction'
                      )
                    "
                  >
                    複製を開く
                  </button>

              </td>
            </tr>
            <tr v-if="!workOrders.length">
              <td :colspan="headers.length" class="text-center">
                データなし。
              </td>
            </tr>
          </tbody>
        </CommonTableComponent>
      </b-col>
    </b-row>
  </b-container>
</template>
